<script>
import Layout from "../../layouts/main";
import appConfig from "@/app.config";
import { mapGetters } from "vuex";
import { requestsMethods, parametersMethods } from "@/state/helpers";
import { getDateWithFormat } from "@/utils";
import axios from "@/axios";

/**
 * Requests components:
 */
export default {
  page: {
    title: "Mis Solicitudes",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
  },
  props: {
    query: {
      type: Object,
      required: false,
      default: () => ({}),
    },
  },
  data() {
    return {
      isBusy: false,
      tableData: [],
      valuePagination: {
        default: 1,
      },
      modalCrearCaso: false,
      datosCase: "",
      title: "Mis Solicitudes",
      items: [
        {
          text: "Mis Solicitudes",
          href: "/",
        },
        {
          text: "Solicitudes",
          active: true,
        },
      ],
      totalRows: 1,
      currentPage: 1,
      perPage: 10,
      pageOptions: [10, 25, 50, 100],
      filter: null,
      filterOn: [],
      sortBy: "N°",
      sortDesc: false,
      token: '',
      url: 'https://casos.mitta.cl/casos/form?p=',
      fields: [
        {
          key: "refnum",
          label: "N°",
          sortable: true,
        },
        {
          key: "asunto",
          label: "Asunto",
          sortable: true,
        },
        {
          key: "fechacreacion",
          label: "Fecha",
          sortable: true,
        },
        {
          key: "idtipodesc",
          label: "Tipo",
          sortable: true,
        },
        {
          key: "idestadodesc",
          label: "Estado",
          sortable: true,
        },
        {
          key: "origen",
          label: "Canal",
          sortable: true,
        }
      ],
    };
  },
  computed: {
    ...mapGetters("requests", { allRequests: "all" }),
  },
  methods: {
    ...requestsMethods,
    ...parametersMethods,
    getDate(date) {
      return getDateWithFormat(date);
    },
    getAll() {
      this.isBusy = true;
      Promise.all([
        this.getAllParameters({ parametro: 1 }),
        this.getAllRequests(),
      ]).then(() => {
        this.setTableData();
        this.isBusy = false;
      });
    },
    setTableData() {
      this.tableData = this.allRequests.data
    },
    getToken(){
      axios.get(`/GetToken?rut=2&${this.$store.getters["rutEmpresa/cuentaSeleccionada"].value}`)
          .then(token => {
            this.token = token.data
            this.url = this.url + this.token
          })
    },
    goToUrl(){
      window.open(this.url)
    },
    editarCasos(requestRow) {
        // const id = this.allRequests.find( request => {
        //     return request['refnum'] === requestRow ['refnum'];
        // });
      this.$router.push({
        name: "editar-casos",
        query: { id: requestRow.id },
      });
    },
  },
  created() {
    this.getAll(true);
    this.getToken();
  },
};
</script>

<template>
  <Layout>
    <!-- <PageHeader :title="title" :items="items" /> -->
    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <b-row align-h="between" align-v="center">
              <h4 class="card-tittle">Mis Solicitudes</h4>

              <a @click="goToUrl" target="_blank" class="btn btn-danger">Nueva Solicitud</a>
            </b-row>
            <p>
              En este espacio encontrará las solicitudes que ha realizado
              anteriormente. Tiene la opción de dar clic sobre el número de
              solicitud y actualizarla <br />
              con información adicional o documentos adjuntos.
              <br /><br />
              Igualmente podrá crear desde esta página una nueva solicitud.
            </p>
            <div class="row mt-4">
              <!-- Inicio Buscador -->
              <div class="col-sm-12 col-md-12">
                <div
                  id="tickets-table_filter"
                  class="dataTables_filter text-md-right"
                >
                  <label class="d-inline-flex align-items-center">
                    Buscar...:
                    <b-form-input
                      v-model="filter"
                      type="search"
                      placeholder="Search..."
                      class="form-control form-control-sm ml-2"
                    ></b-form-input>
                  </label>
                </div>
              </div>
              <!-- Fin Buscador -->
            </div>
            <!-- Inicio Tabla -->
            <div class="table-responsive mb-0">
              <b-table
                :items="tableData"
                :fields="fields"
                responsive="sm"
                :per-page="perPage"
                :current-page="currentPage"
                :sort-by.sync="sortBy"
                :sort-desc.sync="sortDesc"
                :filter="filter"
                :filter-included-fields="filterOn"
                :busy="isBusy"
              >
                <!-- Inicio Spinner en estado "ocupado" de la tabla -->
                <template #table-busy>
                  <div class="text-center text-danger my-2">
                    <b-spinner class="align-middle"></b-spinner>
                  </div>
                </template>
                <!-- Fin Spinner en estado "ocupado" de la tabla -->

                <template #cell(refnum)="row">
                  <a class="pointer" @click="editarCasos(row.item)">{{
                    row.value
                  }}</a>
                </template>
                <template #cell(fechacreacion)="row">
                  {{ getDate(row.value) }}
                </template>
              </b-table>
            </div>

            <!-- Fin Tabla -->
            <!-- Inicio Paginación -->
            <div class="col">
              <div
                class="dataTables_paginate paging_simple_numbers float-right"
              >
                <ul class="pagination pagination-rounded mb-0">
                  <!-- pagination -->
                  <b-pagination
                    class="portal"
                    v-model="currentPage"
                    :per-page="perPage"
                    :total-rows="tableData.length"
                  ></b-pagination>
                </ul>
              </div>
            </div>
            <!-- Fin Paginación -->
            <!-- Inicio Cantidad registros -->
            <div class="col-sm-12 col-md-6">
              <div id="tickets-table_length" class="dataTables_length">
                <label class="d-inline-flex align-items-center">
                  Mostrar&nbsp;
                  <b-form-select
                    v-model="perPage"
                    size="sm"
                    :options="pageOptions"
                  ></b-form-select
                  >&nbsp;entries
                </label>
              </div>
            </div>
            <!-- Fin Cantidad Registros -->
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>
